var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#ae8fea;}.cls-3{fill:#784ace;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "links") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.44,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "user_account_links"
  }, /*#__PURE__*/React.createElement("g", {
    id: "links"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.31,196.82a145.74,145.74,0,0,1,131.77-3.23l72.38-72.38a54,54,0,0,1,76.36,76.35l-72.21,72.21-30.15,30.15a54,54,0,0,1-76.08.25l-.26-.26a54,54,0,0,0-76.1.26l-28,28a144.85,144.85,0,0,0,28.1,39.47l8.27,8.27a145.36,145.36,0,0,0,205.75,0L557,257.09a145.49,145.49,0,0,0,0-205.75l-8.27-8.27a145.49,145.49,0,0,0-205.75,0L224.13,161.88A144.92,144.92,0,0,0,198.31,196.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.68,546.59,54,554.86a145.48,145.48,0,0,0,205.75,0L378.52,436.05a145.58,145.58,0,0,0,25.82-34.94,145.76,145.76,0,0,1-131.78,3.23L198,478.88a54,54,0,0,1-76.36-76.35L196,328.16l28-28a54,54,0,0,1,76.1-.26l.26.26a54,54,0,0,0,76.08-.25l30.15-30.15a144.75,144.75,0,0,0-28.09-39.47L370.24,222a145.38,145.38,0,0,0-205.75,0L45.68,340.84A145.48,145.48,0,0,0,45.68,546.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.c48b93e95f6b55956ac8edba2aa72209.svg";
export { ForwardRef as ReactComponent };